import { CompanySetting } from "domain-entities";
import moment from "moment";
import { MinuteRange } from "../types/MinuteRange";
import { TIME_FORMAT } from "../constants/TIME_FORMAT";
import { getCompanyWorkingHours } from "./getCompanyWorkingHours";

export function getCompanyWorkingMinutes(
	companySetting?: CompanySetting
): MinuteRange {
	const workingHours = getCompanyWorkingHours(companySetting);
	const startMoment = moment(workingHours.start, TIME_FORMAT);
	const endMoment = moment(workingHours.end, TIME_FORMAT);

	const start = startMoment.hours() * 60 + startMoment.minutes();
	const end = endMoment.hours() * 60 + endMoment.minutes();

	return {
		start,
		end,
	};
}
